import { accessToken } from '@carvana/core-auth';
import { datadogRum } from '@datadog/browser-rum';
import { environment, isProd } from '~/constants/environment';
import { BrowserCookies, getUserId } from '~/utilities/index';

function log(status: 'imported' | 'initializing' | 'ready') {
  if (isProd) return;

  console.debug(`VDP DataDog is ${status}`, performance.now());
}

const unwantedViewNames = ['/managepurchase', '/managecustomer'];

log('imported');

export default function initDataDog(sampleRate: number = 10) {
  log('initializing');
  const isAuthUser = accessToken().isValidToken;

  datadogRum.init({
    applicationId: 'b1337a69-f11e-4206-a2ef-4b273beea1cb',
    clientToken: 'pubc4dcb379da198c6154be75c113e30243',
    env: environment,
    sessionSampleRate: isAuthUser ? 100 : sampleRate,
    sessionReplaySampleRate: isAuthUser ? 100 : sampleRate,
    site: 'datadoghq.com',
    service: 'merch-ui',
    version: process.env.APP_VERSION,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      'https://apps.carvana.io',
      'https://apik.carvana.io',
      'https://apps.carvanatech.com',
      'https://apik.carvanatech.com'
    ],
    beforeSend: event => {
      const url = new URL(event.view.url);

      return !unwantedViewNames.includes(url.pathname);
    }
  });

  datadogRum.onReady(() => {
    log('ready');
  });

  datadogRum.setUser({
    browserCookieId: BrowserCookies.get('BrowserCookieId'),
    id: getUserId()
  });
}
